<mat-toolbar color="primary" class="header">
    <button mat-icon-button (click)="toggleMenu()"><mat-icon>menu</mat-icon></button>
    Inventory Manager
    <span class="spacer"></span>
    <button mat-icon-button [matMenuTriggerFor]="appMenu" matTooltip="Applications"><mat-icon>apps</mat-icon></button>
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" matTooltip="Notifications"><mat-icon [matBadgeHidden]="notifications === 0" [matBadge]="notifications" matBadgeColor="warn">notifications</mat-icon></button>
    @if (user) {
<span class="user">
        <img matTooltip="Profile" [matMenuTriggerFor]="userMenu" [src]="'https://firebasestorage.googleapis.com/v0/b/angular-pwa-cf61b.appspot.com/o/' + user.uid + '.svg?alt=media'" />
    </span>
}

</mat-toolbar>

<mat-menu #appMenu="matMenu" yPosition="below" xPosition="before">
    <menu-apps></menu-apps>
</mat-menu>
<mat-menu #notificationMenu="matMenu" yPosition="below" xPosition="before">
    <menu-notifications></menu-notifications>
</mat-menu>
<mat-menu #userMenu="matMenu" yPosition="below" xPosition="before">
    <menu-user></menu-user>
</mat-menu>